import { FC } from "react";
import useDocumentTitle from "@/hooks/useDocumentTitle";
import { CoverImage } from "@/components";
import Image from "@/assets/cover/news_dbg.webp";
import useGlobalLeaderboard from "@/features/leaderboard/hooks/useGloalLeaderboard";
import GlobalLeaderboardTable from "@/features/leaderboard/components/GlobalLeaderboardTable/GlobalLeaderboardTable";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";
import DateObject from "react-date-object";
import { Box, Callout } from "@radix-ui/themes";
import { ExclamationTriangleIcon } from "@radix-ui/react-icons";
import GlobalLeaderboardTableLoader from "@/features/leaderboard/components/GlobalLeaderboardTableLoader/GlobalLeaderboardTableLoader";

/**
 * LeaderboardPage displays the leaderboard for the current month and year.
 *
 * @returns {JSX.Element} The rendered LeaderboardPage component.
 */

const LeaderboardPage: FC = (): JSX.Element => {
  // react-date-object
  const date = new DateObject();

  // Get current month and year
  const currentMonth = "February";
  const currentYear = date.year;
  // const currentMonth = "February";
  // const currentYear = 2025;

  // uid used for fetching the current leaderboard of the current month and year
  const uid = `${currentYear}_${currentMonth}_${brand.tenantId}`;

  // Fetch the leaderboard data
  const { data, loading, error, refetch } = useGlobalLeaderboard(uid);

  // Page Document Title
  useDocumentTitle(`Leaderboard ${currentMonth} ${currentYear}`);

  return (
    <>
      <CoverImage
        src={Image}
        alt="CoverImage"
        heading="Leaderboard"
        desc="Leaderboardet viser hvordan du overordnet har klaret dig, hvis du har deltaget i alle 3 challenges."
      />
      {loading && <GlobalLeaderboardTableLoader />}
      {data && !loading && (
        <GlobalLeaderboardTable
          lastUpdateTimestamp={data.lastUpdateTimestamp}
          leaderboard={data.leaderboard}
          refetch={refetch}
        />
      )}
      {error && (
        <Callout.Root color="red">
          <Callout.Icon>
            <ExclamationTriangleIcon />
          </Callout.Icon>
          <Callout.Text>{error.message}</Callout.Text>
        </Callout.Root>
      )}
    </>
  );
};

export default LeaderboardPage;
